module.exports = __webpack_public_path__ + "img/icone-seguranca-paypal.6247b193.svg";